<template>
  <send-service
    service="letter"
    :header="$t('W2P_CREATE_LETTER')"
    :subheader="$t('W2P_CREATE_LETTER_SUBTEXT')"
  />
</template>

<script>
import SendService from '@/components/common/SendServiceComponent'

export default {
  components: {
    SendService
  }
}
</script>
